import React, { useEffect } from "react";
import { GiCalculator } from "react-icons/gi";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../Poster/Poster.css";

gsap.registerPlugin(ScrollTrigger);

const Poster = () => {
  useEffect(() => {
    const mediaQueryTablet = window.matchMedia("(max-width: 768px)");
    const mediaQueryMobile = window.matchMedia("(max-width: 480px)");

    const applyResponsiveStyles = () => {
      const isMobile = mediaQueryMobile.matches;
      const isTablet = mediaQueryTablet.matches && !isMobile;
      const scaleValue = isMobile ? 1 : 1.5;
      const fontSizeValue = isMobile ? "1.2rem" : "2rem";
      const positionY = isMobile ? 150 : isTablet ? 200 : 250;  // Adjust position Y for different screens
      const positionYFinal = isMobile ? 0 : isTablet ? 10 : 50;  // Final Y position after animation

      gsap.fromTo(
        ".decorated-heading-pca",
        {
          opacity: 1,
          scale: scaleValue,
          y: positionY,
        },
        {
          opacity: 0,
          scale: 1,
          y: positionYFinal,
          scrollTrigger: {
            trigger: ".poster-pca",
            start: "top center",
            end: "bottom top",
            scrub: true,
            delay: 0.4,
          },
        }
      );

      gsap.fromTo(
        ".subheading-pca",
        {
          opacity: 0,
          scale: scaleValue,
          y: positionY,
        },
        {
          opacity: 1,
          scale: 1,
          y: positionYFinal,
          scrollTrigger: {
            trigger: ".poster-pca",
            start: "top center",
            end: "bottom top",
            scrub: true,
            delay: 0.2,
          },
        }
      );

      gsap.fromTo(
        ".main-heading-pca",
        {
          opacity: 0,
          scale: scaleValue,
          y: positionY,
          fontSize: fontSizeValue,
        },
        {
          opacity: 1,
          scale: 1.5,
          y: positionYFinal,
          fontSize: fontSizeValue,
          scrollTrigger: {
            trigger: ".poster-pca",
            start: "top center",
            end: "bottom top",
            scrub: true,
            delay: 0.4,
          },
        }
      );

      gsap.fromTo(
        ".description-pca",
        {
          opacity: 0,
          scale: scaleValue,
          y: positionY,
        },
        {
          opacity: 1,
          scale: 1,
          y: positionYFinal,
          scrollTrigger: {
            trigger: ".poster-pca",
            start: "top center",
            end: "bottom top",
            scrub: true,
            delay: 0.6,
          },
        }
      );

      gsap.fromTo(
        ".contact-btn-pca",
        {
          opacity: 0,
          scale: scaleValue,
          y: positionY,
        },
        {
          opacity: 1,
          scale: 1,
          y: positionYFinal,
          scrollTrigger: {
            trigger: ".poster-pca",
            start: "top center",
            end: "bottom top",
            scrub: true,
            delay: 0.8,
          },
        }
      );
    };

    // Apply styles based on initial load
    applyResponsiveStyles();

    // Apply responsive styles when screen size changes
    mediaQueryTablet.addEventListener("change", applyResponsiveStyles);
    mediaQueryMobile.addEventListener("change", applyResponsiveStyles);

    return () => {
      mediaQueryTablet.removeEventListener("change", applyResponsiveStyles);
      mediaQueryMobile.removeEventListener("change", applyResponsiveStyles);
    };
  }, []);

  return (
    <div className="poster-pca">
      <div className="overlay-content-pca">
        <div className="decorated-heading-pca">
          <GiCalculator className="react-icon-pca" />
        </div>
        <h3 className="subheading-pca">Need Any Guidance?</h3>
<h1 className="main-heading-pca">We Care Numbers</h1>
<p className="description-pca">
  We offer expert financial solutions to help you achieve the growth and 
  security you deserve. Let us manage your success.
</p>

        <button className="contact-btn-pca">Contact Now</button>
      </div>
    </div>
  );
};

export default Poster;
